export const page = {
    height: '100vh'
}
export const content = {
    backgroundImage: 'url("https://images.alphacoders.com/201/thumb-1920-201831.png")',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    flexGrow: '4'
}
export const container = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
}